// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel } from './enterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel {
    'canUpdate'?: boolean;
    'canInsert'?: boolean;
    'skipSearch'?: boolean;
    'model'?: EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel>> = [
        {
            "name":     "canUpdate",
            "baseName": "canUpdate",
            "type":     "boolean"
        },
        {
            "name":     "canInsert",
            "baseName": "canInsert",
            "type":     "boolean"
        },
        {
            "name":     "skipSearch",
            "baseName": "skipSearch",
            "type":     "boolean"
        },
        {
            "name":     "model",
            "baseName": "model",
            "type":     "EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel"
        },
    ];

    static getAttributeTypeMap() {
        return SharedUpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel.attributeTypeMap;
    }
}
